import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function HeroSection() {
  return <section className="relative bg-brand-black text-white overflow-hidden pt-16 pb-12 lg:pt-24 lg:pb-24" data-id="element-52">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-53">
        <div className="flex flex-col-reverse lg:flex-row items-center gap-12 lg:gap-8" data-id="element-54">
          {/* Left Copy */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="w-full lg:w-1/2 flex flex-col items-center lg:items-start text-center lg:text-left" data-id="element-55">
            <p className="text-sm sm:text-base text-gray-400 font-medium mb-3 tracking-wide uppercase" data-id="element-56">
              If you spend hours on your phone or computer, your neck is getting
              worse every day.
            </p>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold leading-tight mb-4" data-id="element-57">
              Fix Your Neck Pain In Minutes
            </h1>
            <p className="text-lg sm:text-xl text-gray-300 mb-8 max-w-lg" data-id="element-58">
              Relieve tension, improve posture and feel instant relief from
              home.
            </p>

            <div className="flex items-center gap-4 mb-8" data-id="element-59">
              <span className="text-2xl text-[#aaa] line-through" data-id="element-60">$59.99</span>
              <span className="text-[28px] sm:text-4xl font-bold text-white" data-id="element-61">
                $24.99
              </span>
              <span className="bg-brand-purple text-white text-sm font-bold px-3 py-1 rounded-full uppercase tracking-wide" data-id="element-62">
                58% OFF
              </span>
            </div>

            <p className="text-yellow-400 text-sm font-semibold mb-3 flex items-center gap-1.5 justify-center lg:justify-start" data-id="element-63">
              <span data-id="element-64">⚠️</span> Limited stock available – selling fast
            </p>
            <a href="https://zenifyliving.com/cart/48194365325482:1?checkout" className="block w-full sm:w-auto text-center bg-brand-purple hover:bg-brand-purple-dark text-white font-bold text-lg py-4 px-8 rounded-full transition-all duration-300 shadow-[0_0_20px_rgba(124,58,237,0.4)] hover:shadow-[0_0_30px_rgba(124,58,237,0.6)] hover:scale-105 mb-6" data-id="element-65">
              GET INSTANT RELIEF NOW
            </a>

            <div className="flex flex-wrap justify-center lg:justify-start gap-4 sm:gap-6 text-sm text-gray-400" data-id="element-66">
              <div className="flex items-center gap-1.5" data-id="element-67">
                <Check className="w-4 h-4 text-brand-purple" data-id="element-68" />
                <span data-id="element-69">Free Shipping</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-70">
                <Check className="w-4 h-4 text-brand-purple" data-id="element-71" />
                <span data-id="element-72">30-Day Guarantee</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-73">
                <Check className="w-4 h-4 text-brand-purple" data-id="element-74" />
                <span data-id="element-75">Secure Checkout</span>
              </div>
            </div>
          </motion.div>

          {/* Right Image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="w-full lg:w-1/2 relative" data-id="element-76">
            <div className="absolute inset-0 bg-brand-purple rounded-3xl blur-[100px] opacity-30" data-id="element-77"></div>
            <img src="https://cdn.magicpatterns.com/uploads/ivDR23d7Fyqv53U8p7hboc/ugc_jardin.png" alt="Woman relaxing outdoors using Zenify neck stretcher" className="relative z-10 w-full h-auto rounded-3xl object-cover shadow-2xl border border-white/10" data-id="element-78" />
          </motion.div>
        </div>
      </div>
    </section>;
}